import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CustomerAttributesService } from '../services/customer-attributes.service';
import { selectCustomerAttributes } from './customer-attributes.selector';
import { of } from 'rxjs';
import { customerAttributesActions, getUpdateStatedIncomeActions } from './customer-attributes.actions';

@Injectable()
export class CustomerAttributesEffect {
  constructor(
    readonly actions$: Actions,
    private readonly store: Store,
    private readonly customerAttributesService: CustomerAttributesService
  ) {}

  getCustomerAttributes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerAttributesActions.start),
      withLatestFrom(this.store.select(selectCustomerAttributes)),
      exhaustMap(([, cachedResponse]) => {
        if (cachedResponse) {
          return of(customerAttributesActions.success({ response: cachedResponse }));
        }

        return this.customerAttributesService.getCustomerAttributes().pipe(
          map((response) => customerAttributesActions.success({ response })),
          catchError((error) => of(customerAttributesActions.error({ error })))
        );
      })
    )
  );

  updateStatedIncome$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUpdateStatedIncomeActions.start),
      switchMap((action) => {
        return this.customerAttributesService.updateStatedIncome(action.request).pipe(
          map(() =>
            getUpdateStatedIncomeActions.success({
              response: {
                ...action.request,
                is_customer_income_attribute_refresh_required: false,
              },
            })
          ),
          catchError((error) => of(getUpdateStatedIncomeActions.error({ error })))
        );
      })
    );
  });
}
